import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  additionalInfo: {
    color: palette.shades[700]
  },
  loaderWrapper: {
    marginTop: '180px',
    textAlign: 'center'
  },
  successBlockWrapper: {
    marginTop: '48px',
    textAlign: 'center'
  },
  stripeWrapper: {
    position: 'relative'
  },
  backButton: {
    position: 'absolute',
    top: '-61px',
    left: '0',
    [breakpointsFunc.breakpoints.down('lg')]: {
      position: 'initial',
      top: 'initial',
      left: 'initial',
      marginBottom: '32px'
    }
  },
  accordionSummary: {
    padding: '15px 30px',
    borderBottom: "1px solid ".concat(palette.shades[300]),
    '& .MuiFormControlLabel-root': {
      marginRight: '0'
    }
  },
  cardLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  cardLabelText: {
    marginLeft: '10px'
  },
  accordion: {
    boxShadow: 'none',
    '&.Mui-expanded': {
      marginBottom: '0'
    }
  },
  accordionDetails: {
    backgroundColor: palette.shades[200],
    padding: '24px',
    borderBottom: "1px solid ".concat(palette.shades[300])
  },
  accordions: {
    marginTop: '24px',
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: '2px',
    '& .MuiAccordion-root': {
      marginTop: '0'
    },
    '& $accordion': {
      '&:last-child $accordionSummary': {
        borderBottom: 'none'
      },
      '&:last-child $accordionDetails': {
        borderTop: "1px solid ".concat(palette.shades[300]),
        borderBottom: 'none'
      }
    }
  },
  subSection: {
    padding: '24px 18px',
    display: 'flex',
    flexDirection: 'column',
    border: "1px solid ".concat(palette.shades[300]),
    '&:last-child': {
      borderRadius: '0 0 2px 2px'
    }
  },
  couponSection: {
    marginTop: '16px'
  },
  tryDemo: {
    marginTop: '16px'
  }
}));
export default useStyles;